(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'DestinationGuide',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var total_items       = 0,
			destination_ids   = Cookies.get('destination_ids') || '',
			$container        = $('.bundle-content');

		$('.destination-bundle').click(function addRemoveDestinationForBundle(e) {
			e.stopPropagation();

			var destination_ids  = Cookies.get('destination_ids') || '', // eslint-disable-line vars-on-top
			    destination_str  = '',
			    destination_id   = $(this).data("id"),
			    ids              = '',
			    max_items        = 10, //	arbitrary
			    i                = 0,
			    min_total_items  = 0;

			if ($(this).prop('checked') === true) {
				if (destination_ids === '') {
					destination_str = destination_id;
					total_items     = 1;
				} else {
					ids         = destination_ids.split('|');
					total_items = ids.length;

					if (ids.length >= max_items) {
						if (ids.length >= max_items) {
							Adzuki.StatusMessage(null, 'You can only bundle up to ' + max_items + ' at a time', 'Max Limit Reached');

							destination_str = destination_ids;
							$(this).prop('checked', false);
						}
					} else {
						total_items++;
						destination_str = destination_ids + '|' + destination_id;
					}
				}
			} else if (destination_ids) {
				destination_str = '';
				ids            = destination_ids.split('|');
				total_items    = 0;

				for (i=0;i<=ids.length;i++) {
					if (parseInt(ids[i]) === parseInt(destination_id)) {
						ids.splice(i, 1);
					} else {
						total_items++;
					}
				}

				destination_str = ids.join("|");
			}

			if (total_items > min_total_items) {
				Cookies.set('destination_ids', destination_str, {
					expires: 7,
					path   : '/'
				});

				showBundleBox();
			} else {
				Cookies.remove('destination_ids');

				hideBundleBox();
			}
		});

		$container.on('click', '.bundle-remove', function bundleRemoveOne(e) {
			e.preventDefault();

			// eslint-disable-next-line vars-on-top
			var destination_ids  = Cookies.get('destination_ids') || '',
			    destination_str  = '',
			    ids             = '',
			    destination_id          = $(this).data("id"),
			    i               = 0,
			    min_total_items = 0,
			    decrementor     = 1;

			ids = destination_ids.split('|');

			for (i=0;i<=ids.length;i++) {
				if (parseInt(ids[i]) !== parseInt(destination_id)) {
					if (destination_str === '' && ids[i] !== destination_id && !isNaN(ids[i])) {
						destination_str = ids[i];
					} else if (ids[i]) {
						destination_str += '|' + ids[i];
					}
				}
			}

			$('.destination-bundle').each(function uncheckOne() {
				if ($(this).data("id") === destination_id) {
					$(this).prop('checked', false);
				}
			});

			total_items = parseInt(ids.length) - decrementor;

			if (total_items > min_total_items) {
				Cookies.set('destination_ids', destination_str, {
					expires: 7,
					path   : '/'
				});

				showBundleBox();
			} else {
				Cookies.remove('destination_ids');
				hideBundleBox();
			}
		});

		$container.on('click', '.bundle-remove-all', function comparisonRemoveAll() {
			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to remove all?',
				confirm: function confirm() {
					Cookies.remove('destination_ids');
					hideBundleBox();

					$('.destination-bundle').each(function uncheckAll() {
						$(this).prop('checked', false);
					});
				}
			});
		});

		$container.on('click', '.bundle-send', function sendBundle() {
			var destination_ids  = Cookies.get('destination_ids') || '';

			document.location = Adzuki.base_uri + '/DestinationContents/sendBundle/' + destination_ids;
		});

		Adzuki.Typeahead(
			'.location-search',
			'/DestinationContents/locations',
			function select(item) {
				$('#destinationguide-destination').val(item.title);
			},
			function template(item) {
				var html = '';

				if (item.title.length > 0) {
					html += item.title;
				}

				return html;
			}
		);

		if (destination_ids !== '') {
			showBundleBox();
		}

		function showBundleBox() {
			var destination_ids  = Cookies.get('destination_ids');

			$('.destination-guide-left').removeClass('col-md-12');
			$('.destination-guide-left').addClass('col-md-8');

			$('.destination-guide-right').removeClass('hidden');
			$('.destination-guide-right').addClass('col-md-4');

			Adzuki.Ajax.get('/DestinationContents/bundleList/' + destination_ids).then(function success(response) {
				$('.bundle-content').html(response);

				$('[data-toggle^="tooltip"]').tooltip();
			});
		}

		function hideBundleBox() {
			$('.destination-guide-right').removeClass('col-md-4');
			$('.destination-guide-right').addClass('hidden');

			$('.destination-guide-left').removeClass('col-md-8');
			$('.destination-guide-left').addClass('col-md-12');

		}

	};
}(jQuery, window.Adzuki || {}));